<!--
 * @Author: caiyuliu
 * @Date: 2025-12-15 09:46:13
 * @LastEditors: caiyuliu
 * @LastEditTime: 2025-12-15 10:04:22
 * @Description: 统计卡片组件
-->
<template>
  <div class="stat-card" :style="{ borderTopColor: color }">
    <div class="stat-icon">{{ icon }}</div>
    <div class="stat-content">
      <div class="stat-value">{{ animatedValue }}</div>
      <div class="stat-title">{{ title }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    icon: {
      type: String,
      default: '📊'
    },
    color: {
      type: String,
      default: '#4CAF50'
    }
  },
  data() {
    return {
      animatedValue: 0
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        this.animateValue(newVal)
      }
    }
  },
  methods: {
    animateValue(target) {
      const duration = 1000
      const start = this.animatedValue
      const startTime = Date.now()

      const animate = () => {
        const now = Date.now()
        const progress = Math.min((now - startTime) / duration, 1)
        const easeProgress = this.easeOutQuad(progress)

        this.animatedValue = Math.floor(start + (target - start) * easeProgress)

        if (progress < 1) {
          requestAnimationFrame(animate)
        }
      }

      requestAnimationFrame(animate)
    },
    easeOutQuad(t) {
      return t * (2 - t)
    }
  }
}
</script>

<style lang="scss" scoped>
.stat-card {
  background: #fff;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-top: 4px solid;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 16px;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  }

  .stat-icon {
    font-size: 48px;
    line-height: 1;
  }

  .stat-content {
    flex: 1;

    .stat-value {
      font-size: 32px;
      font-weight: bold;
      color: #333;
      line-height: 1.2;
      margin-bottom: 4px;
    }

    .stat-title {
      font-size: 14px;
      color: #666;
    }
  }
}

@media (max-width: 768px) {
  .stat-card {
    padding: 16px;

    .stat-icon {
      font-size: 36px;
    }

    .stat-content .stat-value {
      font-size: 24px;
    }
  }
}
</style>
